import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
const OnRenderWrapper = ({ children, onRenderCallback }) => {
    useEffect(() => {
        onRenderCallback();
    }, []);
    return _jsx(_Fragment, { children: children });
};
export default OnRenderWrapper;
